import * as React from 'react';
import { useCallback, useEffect, useState } from 'react';
import { Box, Grid, LinearProgress } from '@mui/material';

import { LayoutDashboard } from '../../../shared/layouts';
import { GenericService } from '../../../shared/services';
import { TestPackageDTO, TestPackageFilterDTO, TestScenarioDTO, TestScenarioFilterDTO, WorkspaceDTO } from '../../../shared/interfaces';
import { ISnackbarAlert, SnackbarAlert, CardList, TextFieldInput, ToolBar, IDialogActions, ICardActions, ICardColumns, IChipFilter, SelectField } from '../../../shared/components';
import { Delete } from '../../../shared/components/confirm-delete/ConfirmDelete';
import { LocalStorange } from '../../../shared/environment';
import { TestScenarioMaintenance } from './TestScenarioMaintenance';
import { TestComponent } from '../test-component/TestComponent';
import { WorkspaceFilterDTO } from '../../../shared/interfaces/testingSphere/WorkspaceFilterDTO';
import { TestAcceptanceCriteriaViewDialog, TestDataIntegrationViewDialog, TestExecutionListViewDialog } from '../..';

interface ITestScenarioProps {
    data: any;
}

export const TestScenario: React.FC<ITestScenarioProps> = ({ data }) => {

    const [workspaceId, setWorkspaceId] = useState('');
    const [workspaceList, setWorkspaceList] = useState<WorkspaceDTO[]>([]);
    const [testPackageList, setTestPackageList] = useState<TestPackageDTO[]>([]);
    const [testScenarioList, setTestScenarioList] = useState<TestScenarioDTO[]>([]);
    const [testScenarioFilterDTO, setTestScenarioFilterDTO] = useState<TestScenarioFilterDTO>();

    const [actionExecuted, setActionExecuted] = useState(false);
    const [newRecord, setNewRecord] = useState('');
    const [editRecord, setEditRecord] = useState('');
    const [deleteRecord, setDeleteRecord] = useState('');
    const [expadedData, setExpandedData] = useState('');
    const [isOpenMaintenance, setIsOpenMaintenance] = useState(false);
    const [testExecutionListView, setTestExecutionListView] = useState('');
    const [testAcceptanceCriteiraListView, setTestAcceptanceCriteriaListView] = useState('');
    const [testDataIntegrationListtView, setTestsDataIntegrartionListView] = useState('');

    const [loading, setLoading] = useState(false);
    const [snackBarMessage, setSnackBarMessage] = useState<ISnackbarAlert>();
    const [isOpenSnackBar, setIsOpenSnackBar] = useState(false);

    const userInfo = JSON.parse(localStorage.getItem(LocalStorange.USERINFO) || '');

    useEffect(() => {
        setTestScenarioFilterDTO({ 
            ...testScenarioFilterDTO, 
            name: '', 
            testPackageId: data.id ?? '' 
        } as TestScenarioFilterDTO);
    }, []);

    useEffect(() => {
        handleWorkspaceGetAllAsync();
        handleTestScenarioGetAllViewAsync();
    }, [testScenarioFilterDTO]);

    useEffect(() => {
        handleTestPackageGetAllAsync();
    }, [workspaceId]);

    useEffect(() => {
        if (actionExecuted)
            handleTestScenarioGetAllViewAsync();
    }, [actionExecuted]);

    const handleListGetAll = useCallback(async (listId: string, setList: any) => {
        const valueListFilterDTO = {
            value: '',
            listId: listId,
            orderBy: 'value ASC'
        };
        GenericService.GetAllAsync1(
            'parmsphere.valueList',
            valueListFilterDTO,
            setLoading,
            setList,
            showMessage
        );
    }, []);

    const handleWorkspaceGetAllAsync = useCallback(async () => {
        const workspaceFilterDTO: WorkspaceFilterDTO = {
            name: '',
            companyId: userInfo.user.companyId,
        };
        GenericService.GetAllAsync1('testingsphere.workspace', workspaceFilterDTO, setLoading, setWorkspaceList, showMessage);
    }, []);

    const handleTestPackageGetAllAsync = useCallback(async () => {
        const testPackageFilterDTO: TestPackageFilterDTO = {
            name: '',
            workspaceId: workspaceId,
            companyId: userInfo.user.companyId,
        };
        GenericService.GetAllViewAsync1('testingsphere.testpackage', testPackageFilterDTO, setActionExecuted, setLoading, setTestPackageList, showMessage);
    }, []);

    const handleTestScenarioGetAllViewAsync = useCallback(async () => {
        if (testScenarioFilterDTO === undefined)
            return;
        GenericService.GetAllViewAsync1('testingsphere.testScenario', testScenarioFilterDTO, setActionExecuted, setLoading, setTestScenarioList, showMessage, true);
    }, [testScenarioFilterDTO]);

    const handleClearFilterClick = () => {
        setTestScenarioFilterDTO({ 
            ...testScenarioFilterDTO,
            name: '' 
        } as TestScenarioFilterDTO);
    };

    function handleSearchClick() {
        handleTestScenarioGetAllViewAsync();
    }

    const handleNew = () => {
        setNewRecord('data');
        setEditRecord('');
        setDeleteRecord('');
        setTestExecutionListView('');
        setTestsDataIntegrartionListView('');
        setTestAcceptanceCriteriaListView('');
        setIsOpenMaintenance(true);
    };

    const handleViewDetatils = (data: string) => {
        setNewRecord('');
        setEditRecord(data);
        setDeleteRecord('');
        setTestExecutionListView('');
        setTestsDataIntegrartionListView('');
        setTestAcceptanceCriteriaListView('');
        setIsOpenMaintenance(true);
    };

    const handleDelete = (data: string) => {
        setNewRecord('');
        setDeleteRecord(data);
        setEditRecord('');
        setTestExecutionListView('');
        setTestsDataIntegrartionListView('');
        setTestAcceptanceCriteriaListView('');
        setIsOpenMaintenance(true);
    };

    const handleTestExecutionView = (data: string) => {
        setNewRecord('');
        setEditRecord('');
        setDeleteRecord('');
        setTestExecutionListView(data);
        setTestsDataIntegrartionListView('');
        setTestAcceptanceCriteriaListView('');
        setIsOpenMaintenance(true);
    };

    const handleTestAcceptanceCriteriaView = (data: string) => {
        setNewRecord('');
        setEditRecord('');
        setDeleteRecord('');
        setTestExecutionListView('');
        setTestsDataIntegrartionListView('');
        setTestAcceptanceCriteriaListView(data);
        setIsOpenMaintenance(true);
    };

    const handleTestDataIntegrationView = (data: string) => {
        setNewRecord('');
        setEditRecord('');
        setDeleteRecord('');
        setTestExecutionListView('');
        setTestAcceptanceCriteriaListView('');
        setTestsDataIntegrartionListView(data);
        setIsOpenMaintenance(true);
    };

    const handleClone = (data: any) => {
        const testScenarioFilterDTO: TestScenarioFilterDTO = {
            id: data.id
        };
        GenericService.PostGenericAsync1('testingsphere.testScenario', 'CloneAsync', testScenarioFilterDTO, setActionExecuted, setLoading, showMessage);
    };

    const toolBarActions: IDialogActions[] = [
        { id: 'new', text: 'New TestScenario', icon: 'add_circle_outlined', iconColor: 'primary', setAction: handleNew },
    ];

    const cardActions: ICardActions[] = [
        { id: 'viewDetails', toolTip: 'View Details', icon: 'preview_outlined', iconColor: 'primary', setAction: handleViewDetatils },
        { id: 'delete', toolTip: 'Delete', icon: 'delete_outlined', iconColor: 'error', setAction: handleDelete },
        { id: 'cloneTestScenario', toolTip: 'Clone TestScenario', icon: 'file_copy_outlined', iconColor: 'info', setAction: handleClone },
        { id: 'viewTestExecution', toolTip: 'TestExecution', icon: 'playlist_add_check_outlined', iconColor: 'info', setAction: handleTestExecutionView },
        { id: 'viewTestAcceptanceCriteria', toolTip: 'Test Acceptance Critera', icon: 'offline_pin_outlined', iconColor: 'info', setAction: handleTestAcceptanceCriteriaView },
        { id: 'viewTestDataIntegration', toolTip: 'Test Data Integration', icon: 'low_priority_outlined', iconColor: 'info', setAction: handleTestDataIntegrationView },
    ];

    const chipFilters: IChipFilter[] = [
        { label: 'Total Records', value: testScenarioList.length },
        { label: 'Name', value: testScenarioFilterDTO?.name },
        { label: 'Workspace', value: !data ? workspaceList.find(x => x.id === workspaceId)?.name : undefined },
        { label: 'TestPackage', value: !data ? testPackageList.find(x => x.id === testScenarioFilterDTO?.testPackageId)?.name : undefined },
    ];

    const columns: ICardColumns[] = [
        { field: 'name', label: 'Name', size: 4, type: 'text', visible: true, isChip: false, hasFieldLine: false, hasToolTip: true },
        { field: 'executionStatus', label: 'Execution Status', size: 1, type: 'text', visible: true, isChip: true, hasFieldLine: false, hasToolTip: true },
        { field: 'startExecutionDateTime', label: 'Start Execution', size: 2, type: 'dateTime', visible: true, isChip: false, hasFieldLine: false },
        { field: 'endExecutionDateTime', label: 'End Execution', size: 2, type: 'dateTime', visible: true, isChip: false, hasFieldLine: false },
        { field: 'elapseTime', label: 'ElapseTime', size: 1, type: 'text', visible: true, isChip: false, hasFieldLine: false },
        { field: 'orderExecution', label: 'Order Execution', size: 1, type: 'text', visible: true, isChip: false, hasFieldLine: false },
        { field: 'cycle', label: 'Cycle', size: 1, type: 'text', visible: true, isChip: true, hasFieldLine: false },
    ];

    function showMessage(message: string, type: 'error' | 'info' | 'success' | 'warning') {
        const msg: ISnackbarAlert = {
            id: 'message',
            message: message,
            type: type,
        };
        setSnackBarMessage(msg);
        setIsOpenSnackBar(true);
    }

    return (
        <React.Fragment>
            {isOpenSnackBar && (
                <SnackbarAlert
                    snackBarAlert={snackBarMessage}
                    setIsOpen={setIsOpenSnackBar}
                    isOpen={isOpenSnackBar}
                />
            )}
            <LayoutDashboard title='TESTCENARIO'>
                <ToolBar
                    clickSearch={handleSearchClick}
                    clickClearFilter={handleClearFilterClick}
                    chipFilters={chipFilters}
                    actions={toolBarActions}
                >
                    <Grid container spacing={1}>
                        <Grid item xs={12} md={4}>
                            <TextFieldInput
                                id='name'
                                label='Name'
                                value={testScenarioFilterDTO?.name}
                                setValue={setTestScenarioFilterDTO}
                                obj={testScenarioFilterDTO}
                                placeholder={'Name'}
                                maxLength={200}
                            />
                        </Grid>
                        {!data && (
                            <React.Fragment>
                                <Grid item xs={12} md={4}>
                                    <SelectField
                                        id='workspaceId'
                                        label='Workspace Name'
                                        setValue={setWorkspaceId}
                                        value={workspaceId}
                                        valueList={workspaceList}
                                    />
                                </Grid>
                                <Grid item xs={12} md={4}>
                                    <SelectField
                                        id='testPackageId'
                                        label='TestPackage Name'
                                        value={testScenarioFilterDTO?.testPackageId}
                                        setValue={setTestScenarioFilterDTO}
                                        obj={testScenarioFilterDTO}
                                        valueList={testPackageList}
                                        hasNoneSelect={true}
                                    />
                                </Grid>
                            </React.Fragment>
                        )}
                    </Grid>
                </ToolBar>
                {loading && (
                    <LinearProgress sx={{ borderRadius: 3, mt: - 0.7, mb: 0.2 }} />
                )}
                <CardList
                    columns={columns}
                    rows={testScenarioList}
                    actions={cardActions}
                    hasChildren={true}
                    setRowExpanded={setExpandedData}
                    cardSize={12}
                    childrenTitle={'TEST COMPONENT'}
                    childrenComponent={(
                        <Box width={'100%'}>
                            <TestComponent data={expadedData} />
                        </Box>
                    )}
                />
                {newRecord && (
                    <TestScenarioMaintenance
                        data={''}
                        setIsOpenMaintenance={setIsOpenMaintenance}
                        isOpenMaintenance={isOpenMaintenance}
                        setActionExecuted={setActionExecuted}
                        parentId={data.id ?? testScenarioFilterDTO?.testPackageId}
                    />
                )}
                {editRecord && (
                    <TestScenarioMaintenance
                        data={editRecord}
                        setIsOpenMaintenance={setIsOpenMaintenance}
                        isOpenMaintenance={isOpenMaintenance}
                        setActionExecuted={setActionExecuted}
                    />
                )}
                {deleteRecord && (
                    <Delete
                        entity={'testingsphere.testscenario'}
                        data={deleteRecord}
                        setIsOpenDiaglog={setIsOpenMaintenance}
                        isOpenDialog={isOpenMaintenance}
                        setActionExecuted={setActionExecuted}
                    />
                )}
                {testExecutionListView && (
                    <TestExecutionListViewDialog
                        data={testExecutionListView}
                        parentId={'testScenarioId'}
                        setIsOpenMaintenance={setIsOpenMaintenance}
                        isOpenMaintenance={isOpenMaintenance}
                        setActionExecuted={setActionExecuted}
                    />
                )}
                {testAcceptanceCriteiraListView && (
                    <TestAcceptanceCriteriaViewDialog
                        data={testAcceptanceCriteiraListView}
                        parentId={'testScenarioId'}
                        setIsOpenMaintenance={setIsOpenMaintenance}
                        isOpenMaintenance={isOpenMaintenance}
                        setActionExecuted={setActionExecuted}
                    />
                )}
                {testDataIntegrationListtView && (
                    <TestDataIntegrationViewDialog
                        data={testDataIntegrationListtView}
                        parentId={'testScenarioId'}
                        setIsOpenMaintenance={setIsOpenMaintenance}
                        isOpenMaintenance={isOpenMaintenance}
                        setActionExecuted={setActionExecuted}
                    />
                )}
            </LayoutDashboard>
        </React.Fragment >
    );
};